'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Route, Switch } from 'react-router-dom';
import HubspotApp from './components/app/HubspotApp';
import LoginLanding from './components/v1/LoginLanding';
import GoogleLoginConfirmationLanding from './components/google/GoogleLoginConfirmationLanding';
import LoginConfirmationLanding from './components/loginConfirmationLanding/LoginConfirmationLanding';
import OneTimePasswordComponent from './components/otp/OneTimePassword';
import Loadable from 'UIComponents/decorators/Loadable';
import AsyncComponentErrorHandler from './utils/AsyncComponentErrorHandler';
import AsyncComponentLoading from './components/AsyncComponentLoading';
import InternalLoginCookies from './components/InternalLoginCookies';
const ConfirmToLoginPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-Extra" */
  './components/confirm-to-login/ConfirmToLoginPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TrustTokenPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-Extra" */
  './components/trust-token/TrustTokenPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const NotFoundLanding = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-Extra" */
  './components/NotFoundLanding').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const PasswordResetPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-Extra" */
  './components/password/PasswordResetPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const RequestResetEmailPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-Extra" */
  './components/password/RequestResetEmailPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const SsoAcsPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-Extra" */
  './components/sso/SsoAcsPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const SsoCompletionPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-Extra" */
  './components/sso/SsoCompletionPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const SsoLoginPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-Extra" */
  './components/sso/SsoLoginPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorAuthPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-TwoFactor" */
  './components/two-factor-auth/TwoFactorAuthPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRecoveryPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-TwoFactor" */
  './components/two-factor-auth/TwoFactorRecoveryPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRecoverySupportPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-TwoFactor" */
  './components/two-factor-auth/TwoFactorRecoverySupportPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRecoveryAdminPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-TwoFactor" */
  './components/two-factor-auth/TwoFactorRecoveryAdminPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRecoveryVerifyPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-TwoFactor" */
  './components/two-factor-auth/TwoFactorRecoveryVerifyPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const LoginLandingPageBeta = Loadable({
  loader: () => import(
  /* webpackChunkName: "chunk-TwoFactor" */
  './components/v3/LoginLandingPageBeta').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
export default /*#__PURE__*/_jsx(Route, {
  path: "/",
  render: ({
    location
  }) => /*#__PURE__*/_jsx(HubspotApp, {
    location: location,
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/",
        route: {
          name: 'login'
        },
        render: props => /*#__PURE__*/_jsx(LoginLanding, Object.assign({}, props, {
          route: {
            name: 'login'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/beta",
        route: {
          name: 'login-beta'
        },
        render: props => /*#__PURE__*/_jsx(LoginLandingPageBeta, Object.assign({}, props, {
          route: {
            name: 'login-beta'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/chatspot",
        route: {
          name: 'login-chatspot'
        },
        render: props => /*#__PURE__*/_jsx(LoginLandingPageBeta, Object.assign({}, props, {
          route: {
            name: 'login-chatspot'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/connect",
        route: {
          name: 'login-connect'
        },
        render: props => /*#__PURE__*/_jsx(LoginLandingPageBeta, Object.assign({}, props, {
          route: {
            name: 'login-connect'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/sso",
        render: props => /*#__PURE__*/_jsx(SsoLoginPage, Object.assign({}, props, {
          route: {
            name: 'sso-login'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/sso/acs",
        render: props => /*#__PURE__*/_jsx(SsoAcsPage, Object.assign({}, props, {
          route: {
            name: 'sso-acs'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/sso/complete",
        render: props => /*#__PURE__*/_jsx(SsoCompletionPage, Object.assign({}, props, {
          route: {
            name: 'sso-complete'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/forgot",
        render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
          updateType: "forgot",
          route: {
            name: 'forgot'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/password-leak",
        render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
          updateType: "passwordLeak",
          route: {
            name: 'password-leak'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/suspicious-activity",
        render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
          updateType: "suspiciousActivity",
          route: {
            name: 'suspicious-activity'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/idle-user",
        render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
          updateType: "idleUser",
          route: {
            name: 'idle-user'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/beta/idle-user",
        render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
          updateType: "idleUser",
          route: {
            name: 'idle-user'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/update-password",
        render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
          updateType: "updatePassword",
          route: {
            name: 'updatePassword'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/two-factor",
        render: props => /*#__PURE__*/_jsx(TwoFactorAuthPage, Object.assign({}, props, {
          route: {
            name: 'twoFactorAuth'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/two-factor/recovery",
        render: props => /*#__PURE__*/_jsx(TwoFactorRecoveryPage, Object.assign({}, props, {
          route: {
            name: 'twoFactorRecovery'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/two-factor/support-recovery",
        render: props => /*#__PURE__*/_jsx(TwoFactorRecoverySupportPage, Object.assign({}, props, {
          route: {
            name: 'twoFactorRecoverySupport'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/two-factor/admin-recovery",
        render: props => /*#__PURE__*/_jsx(TwoFactorRecoveryAdminPage, Object.assign({}, props, {
          route: {
            name: 'twoFactorRecoveryAdmin'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/two-factor/recovery-verify",
        render: props => /*#__PURE__*/_jsx(TwoFactorRecoveryVerifyPage, Object.assign({}, props, {
          route: {
            name: 'twoFactorRecoveryConfirmation'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/confirm-to-login",
        render: props => /*#__PURE__*/_jsx(ConfirmToLoginPage, Object.assign({}, props, {
          route: {
            name: 'confirmToLogin'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/passwordReset",
        render: props => /*#__PURE__*/_jsx(PasswordResetPage, Object.assign({}, props, {
          route: {
            name: 'passwordReset'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/googleLoginRedirect",
        render: props => /*#__PURE__*/_jsx(GoogleLoginConfirmationLanding, Object.assign({}, props, {
          route: {
            name: 'googleRedirect'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/googleLoginLoopback",
        render: props => /*#__PURE__*/_jsx(LoginConfirmationLanding, Object.assign({}, props, {
          loginType: "GOOGLE",
          route: {
            name: 'googleLoopbackRedirect'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/microsoftLoginRedirect",
        render: props => /*#__PURE__*/_jsx(LoginConfirmationLanding, Object.assign({}, props, {
          loginType: "MICROSOFT",
          route: {
            name: 'microsoftRedirect'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/trust-token",
        render: props => /*#__PURE__*/_jsx(TrustTokenPage, Object.assign({}, props, {
          route: {
            name: 'trustToken'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/otp",
        render: props => /*#__PURE__*/_jsx(OneTimePasswordComponent, Object.assign({}, props, {
          route: {
            name: 'otp'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/internal-app",
        route: {
          name: 'internal'
        },
        render: props => /*#__PURE__*/_jsx(InternalLoginCookies, Object.assign({}, props, {
          route: {
            name: 'internal'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        render: props => /*#__PURE__*/_jsx(NotFoundLanding, Object.assign({}, props, {
          route: {
            name: 'notFound'
          }
        }))
      })]
    })
  })
});